export default {
  IPFS_GATEWAY: "https://ipfs.io/ipfs/",
  ROBONOMICS: {
    version: 5
  },
  INFURA_KEY: "c1ea69ab1e0a4c6aa6a9dcd0641aecc7"
};
